import { UiSelect } from "@smp/ui";
import { useField } from "formik";
import { useMemo } from "react";

import { IFormSelectProps } from "./form_select.types";

export const FormSelect = ({ name, ...props }: IFormSelectProps) => {
  const [field, meta] = useField(name);
  return useMemo(
    () => (
      <UiSelect
        error={!!meta.touched && !!meta.error}
        errorMessage={
          !!meta.touched ? (meta.error ? meta.error : undefined) : undefined
        }
        {...field}
        {...props}
      />
    ),
    [field, meta.error, meta.touched, props],
  );
};
